module.exports = __webpack_public_path__ + "img/logo.6f72f968.png";